import { render, staticRenderFns } from "./activityRewards.vue?vue&type=template&id=44d631d8&scoped=true"
import script from "./activityRewards.vue?vue&type=script&lang=js"
export * from "./activityRewards.vue?vue&type=script&lang=js"
import style0 from "./activityRewards.vue?vue&type=style&index=0&id=44d631d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d631d8",
  null
  
)

export default component.exports